import { useFormikContext } from 'formik';
import { useEffect } from 'react';

export const useGuestUpdate = ({ guests, attendeesAttributes }) => {
  const { setFieldValue, values } = useFormikContext();

  useEffect(() => {
    guests.forEach((guest) => {
      attendeesAttributes
        .map((attendee, i) => (attendee.guest_id === guest.guest_id ? i : ''))
        .filter(String)
        .forEach((index) => {
          setFieldValue(
            `network_events_booking[attendees_attributes][${index}]`,
            {
              ...values.network_events_booking.attendees_attributes[index],
              ...guest,
            },
          );
        });
    });
  }, [guests]);
};
